import { render, staticRenderFns } from "./login-box-popup.vue?vue&type=template&id=2d76992d&scoped=true"
import script from "./login-box-popup.vue?vue&type=script&lang=js"
export * from "./login-box-popup.vue?vue&type=script&lang=js"
import style0 from "./login-box-popup.vue?vue&type=style&index=0&id=2d76992d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d76992d",
  null
  
)

export default component.exports